import { useEffect, useState } from 'react';
import { getFileSuffix, getTypeBySuffix, iconMap } from '../../utils';
import MyIcon from '../MyIcon';
import { Display } from '../Display/Display';
import './style.scss';
import pdf from '@/assets/images/fileType/pdf.svg';
import excel from '@/assets/images/fileType/excel.svg';
import word from '@/assets/images/fileType/word.svg';
import ppt from '@/assets/images/fileType/ppt.svg';
import img from '@/assets/images/fileType/img.svg';
import archive from '@/assets/images/fileType/archive.svg';
import file from '@/assets/images/fileType/file.svg';
import link from '@/assets/images/fileType/link.svg';
import epub from '@/assets/images/fileType/epub.svg';
import html from '@/assets/images/fileType/html.svg';
import md from '@/assets/images/fileType/md.svg';
import txt from '@/assets/images/fileType/txt.svg';
const imgMap = {
    pdf,
    excel,
    word,
    ppt,
    image: img,
    archive,
    file,
    link,
    epub,
    html,
    md,
    txt
};
export const getFileIcon = ({ suffix, allFileName }) => {
    let extType = suffix || getFileSuffix(allFileName);
    let groupType = getTypeBySuffix(extType) || 'file';
    return imgMap[groupType] || file;
};
const FileType = (props) => {
    const { showType = true, fileName, suffix, icon } = props;
    const [data, setData] = useState({
        icon: 'icon-file',
        type: ''
    });
    const getImgMap = (allFileName) => {
        if (!allFileName) {
            return false;
        }
        let extType = suffix || getFileSuffix(allFileName);
        let groupType = getTypeBySuffix(extType);
        let fileIcon = iconMap[groupType];
        setData({
            icon: fileIcon || 'icon-file',
            type: groupType || 'file',
            extType: extType.toUpperCase()
        });
    };
    useEffect(() => {
        getImgMap(fileName);
    }, [fileName]);
    return (
        <>
            <span className={'file-icon-wrap'}>
                <Display show={imgMap[data.type]}>
                    <span data-type={data.type} className="file-icon">
                        {/* <MyIcon type={data.icon}></MyIcon> */}
                        <img src={icon || imgMap[data.type]} alt="" />
                    </span>
                </Display>
                <Display show={showType}>
                    <span className="file-type">{data.extType}</span>
                </Display>
            </span>
        </>
    );
};

export default FileType;
